import React, { FC } from 'react';
import cn from 'classnames';
import { ReactComponent as BusinessIcon } from '@assets/serviceCatalog/business.svg';
import { ReactComponent as DocumentIcon } from '@assets/serviceCatalog/document.svg';
import { ReactComponent as FamilyIcon } from '@assets/serviceCatalog/family.svg';
import { ReactComponent as HomeIcon } from '@assets/serviceCatalog/home.svg';
import { ReactComponent as OtherIcon } from '@assets/serviceCatalog/other.svg';
import { ReactComponent as PensionIcon } from '@assets/serviceCatalog/pension.svg';
import { ReactComponent as RitualIcon } from '@assets/serviceCatalog/ritual.svg';
import { ReactComponent as SocialHelpIcon } from '@assets/serviceCatalog/social-help.svg';
import { ReactComponent as TaxesIcon } from '@assets/serviceCatalog/taxes.svg';
import { ReactComponent as TransportIcon } from '@assets/serviceCatalog/transport.svg';
import { ReactComponent as UtilitiesIcon } from '@assets/serviceCatalog/utilities.svg';
import { ReactComponent as WorkIcon } from '@assets/serviceCatalog/work.svg';
import { CATEGORY_TYPES } from '@helpers/formatServicesCatalogToClient';
import st from './CategoriesList.module.css';

export const CATEGORY_LIST_VIEW_TYPES = {
  CATEGORY: 'CATEGORY',
  SUBCATEGORY: 'SUBCATEGORY',
};

const categoriesIcons = {
  [CATEGORY_TYPES.BUSINESS]: BusinessIcon,
  [CATEGORY_TYPES.UTILITIES]: UtilitiesIcon,
  [CATEGORY_TYPES.TAXES]: TaxesIcon,
  [CATEGORY_TYPES.HOME]: HomeIcon,
  [CATEGORY_TYPES.DOCUMENT]: DocumentIcon,
  [CATEGORY_TYPES.PENSION]: PensionIcon,
  [CATEGORY_TYPES.TRANSPORT]: TransportIcon,
  [CATEGORY_TYPES.WORK]: WorkIcon,
  [CATEGORY_TYPES.FAMILY]: FamilyIcon,
  [CATEGORY_TYPES.SOCIAL]: SocialHelpIcon,
  [CATEGORY_TYPES.RITUAL]: RitualIcon,
  [CATEGORY_TYPES.OTHER]: OtherIcon,
};

type CategoriesListProps = {
  categories: any;
  viewType?: any;
  category?: {
    id: number | string;
    title: string;
  };
  onCategorySelect: (item: any) => void;
  buttonTestId?: string;
};

const CategoriesList: FC<CategoriesListProps> = ({
  categories,
  viewType = CATEGORY_LIST_VIEW_TYPES.CATEGORY,
  category = null,
  onCategorySelect,
  buttonTestId = '',
}) => (
  <ul className={st.list}>
    {categories.map((item) => {
      const Icon = categoriesIcons[item.slug];
      return (
        <li key={item.id}>
          <button
            type="button"
            data-testid={buttonTestId}
            className={cn(st.itemSelect, {
              [st.itemSelectActive]: category?.id === item.id,
            })}
            onClick={() => onCategorySelect(item)}
          >
            <span className={st.itemTitle}>{item.name}</span>
            {viewType === CATEGORY_LIST_VIEW_TYPES.CATEGORY && (
              <Icon className={st.itemIcon} />
            )}
            {viewType === CATEGORY_LIST_VIEW_TYPES.CATEGORY && (
              <span className={st.itemCount}>{item.servicesCount}</span>
            )}
          </button>
        </li>
      );
    })}
  </ul>
);

export default CategoriesList;
